import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaReact,
  FaNodeJs,
  FaDatabase,
  FaGitAlt,
  FaDocker,
  FaPalette,
} from 'react-icons/fa';
import {
  SiNextdotjs,
  SiTypescript,
  SiRedux,
  SiMongodb,
  SiExpress,
  SiTailwindcss,
  SiJavascript,
  SiPostgresql,
  SiMysql,
} from 'react-icons/si'; 

const Skills = () => {
  const [activeTab, setActiveTab] = useState('frontend');

  const skillCategories = {
    frontend: [
      { name: 'React.js', icon: <FaReact />, level: 95 },
      { name: 'Next.js', icon: <SiNextdotjs />, level: 90 },
      { name: 'TypeScript', icon: <SiTypescript />, level: 88 },
      { name: 'JavaScript (ES6+)', icon: <SiJavascript />, level: 95 },
      { name: 'Redux/Redux Toolkit', icon: <SiRedux />, level: 90 },
      { name: 'Tailwind CSS', icon: <SiTailwindcss />, level: 92 },
      { name: 'Material-UI', icon: <FaPalette />, level: 85 },
    ],
    backend: [
      { name: 'Node.js', icon: <FaNodeJs />, level: 92 },
      { name: 'Express.js', icon: <SiExpress />, level: 90 },
      { name: 'MongoDB', icon: <SiMongodb />, level: 93 },
      { name: 'PostgreSQL', icon: <SiPostgresql />, level: 80 },
      { name: 'MySQL', icon: <SiMysql />, level: 82 },
      { name: 'RESTful APIs', icon: <FaDatabase />, level: 95 },
    ],
    tools: [
      { name: 'Git & GitHub', icon: <FaGitAlt />, level: 90 },
      { name: 'Docker', icon: <FaDocker />, level: 75 },
      { name: 'CI/CD', icon: <FaReact />, level: 78 },
      { name: 'Vercel/Netlify', icon: <SiNextdotjs />, level: 85 },
    ],
  };

  const additionalSkills = [
    'LangChain',
    'Pinecone Vector DB',
    'RAG (Retrieval-Augmented Generation)',
    'Zustand',
    'Recoil',
    'React Context API',
    'Socket.io',
    'WebSockets',
    'Framer Motion',
    'React Hook Form',
    'Formik & Yup',
    'Recharts',
    'Chart.js',
    'JWT & bcrypt',
    'OAuth2',
    'Passport.js',
    'Sequelize ORM',
    'Drizzle ORM',
    'Jest Testing',
    'Webpack',
    'Vite',
    'SASS/SCSS',
    'Styled Components',
    'Chakra UI',
    'Ant Design',
    'Shadcn UI',
    'Google Maps API',
    'WhatsApp Business API',
    'Cron Jobs',
    'Webhooks',
    'Lighthouse Optimization',
  ];

  return (
    <section className="skills section" id="skills">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Technical Skills</h2>
          <p className="section-subtitle">Technologies I work with</p>
        </motion.div>

        <div className="skills-tabs">
          <button
            className={`tab-btn ${activeTab === 'frontend' ? 'active' : ''}`}
            onClick={() => setActiveTab('frontend')}
          >
            Frontend
          </button>
          <button
            className={`tab-btn ${activeTab === 'backend' ? 'active' : ''}`}
            onClick={() => setActiveTab('backend')}
          >
            Backend
          </button>
          <button
            className={`tab-btn ${activeTab === 'tools' ? 'active' : ''}`}
            onClick={() => setActiveTab('tools')}
          >
            Tools & DevOps
          </button>
        </div>

        <motion.div
          className="skills-grid"
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          {skillCategories[activeTab].map((skill, index) => (
            <motion.div
              key={index}
              className="skill-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="skill-header">
                <div className="skill-icon">{skill.icon}</div>
                <div className="skill-info">
                  <h3>{skill.name}</h3>
                  <span>{skill.level}%</span>
                </div>
              </div>
              <div className="skill-bar">
                <motion.div
                  className="skill-progress"
                  initial={{ width: 0 }}
                  whileInView={{ width: `${skill.level}%` }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: true }}
                />
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="additional-skills"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <h3>Additional Technologies & Tools</h3>
          <div className="skills-tags">
            {additionalSkills.map((skill, index) => (
              <motion.span
                key={index}
                className="skill-tag"
                whileHover={{ scale: 1.1, y: -5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                {skill}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;